<div class="container">
  <p class="label">{{label}}</p>
  <mat-form-field appearance="outline" [style.fontSize]="'12px'">
    <textarea matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="10"
      [formControl]="control"
      (input)="updateValue($event)"
      (blur)="handleBlur()">
    </textarea>
  </mat-form-field>
</div>